const PREF_KEY = "akin_input_mode";

export function getInputModePref(): "text" | "voice" {
	return (localStorage.getItem(PREF_KEY) as "text" | "voice") ?? "voice";
}

export function saveInputModePref(mode: "text" | "voice") {
	localStorage.setItem(PREF_KEY, mode);
}
